module.exports = __webpack_public_path__ + "static/img/retail2.6281243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retail2.png
// module id = ifsm
// module chunks = 2